import Annotation from '@/components/Annotation';
import PageLayout from '@/components/PageLayout';
import PageConPc from '@/components/productSmart/glacierWave';
import SEOlinksA from '@/components/SEOlinksA';
import PageConH5 from '@/componentsH5/productSmart/glacierWave';
import { getGlacierWave2Timeline } from '@/constants/glacierAndWave2';
import { getHostApi } from '@/utils';
import getCanEnterFlag from '@/utils/getCanEnterFlag';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { useGlobal } from '@/utils/useGlobal';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';

// 产品详情页参数
export default function Page({ SEO }: any) {
    const { useRouter, useLang, getSystemTime, isMobile } = useGlobal();
    const router = useRouter();
    const { t } = useLang('glacierwave');
    const [theme, setTheme] = useState('black');
    const { locale } = router;
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const { flag1, flag2, flag3 } = getCanEnterFlag(router?.query?.cid); // 提前打开4-26号
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const TIME_LINE = getGlacierWave2Timeline(locale, flag3 || flag2 || flag1);

    // 倒计时三个时间段
    const startTimeStamp: number = new Date(TIME_LINE?.teaser || 0).getTime();
    const detailTimeStamp: number = new Date(TIME_LINE?.detail || 0).getTime();
    const shopifyTimeStamp: number = new Date(TIME_LINE?.shopify || 0).getTime();
    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 计时器
    const timer: any = useRef(null);
    const [stage, setStage] = useState(() => {
        if (flag3 || (serverTimeStamp?.current >= shopifyTimeStamp && shopifyTimeStamp !== 0)) {
            return 3;
        }
        if (flag2 || (serverTimeStamp?.current >= detailTimeStamp && detailTimeStamp !== 0)) {
            return 2;
        }
        if (flag1 || (serverTimeStamp?.current >= startTimeStamp && startTimeStamp !== 0)) {
            return 1;
        }
        return 0;
    });

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    useEffect(() => {
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        // 倒计时结束完成之前一直执行定时器任务
        if (
            (serverTimeStamp.current < shopifyTimeStamp && shopifyTimeStamp !== 0) ||
            (shopifyTimeStamp === 0 && detailTimeStamp !== 0 && serverTimeStamp.current < detailTimeStamp)
        ) {
            timer.current = setInterval(() => {
                serverTimeStamp.current += 1000;
                if (flag3 || (serverTimeStamp.current >= shopifyTimeStamp && shopifyTimeStamp !== 0)) {
                    clearInterval(timer.current);
                    return stage !== 3 && setStage(3);
                }
                if (flag2 || (serverTimeStamp.current >= detailTimeStamp && detailTimeStamp !== 0)) {
                    if (locale === 'kr') {
                        router.push('/404');
                    }
                    return stage !== 2 && setStage(2);
                }
                if (flag1 || (serverTimeStamp.current >= startTimeStamp && startTimeStamp !== 0)) {
                    return stage !== 1 && setStage(1);
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
        }
        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    useEffect(() => {
        if (!['jp', 'kr', 'au'].includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['jp', 'kr', 'au']} locale={locale} pathname={'glacier-and-wave-2-teaser'} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon stage={stage} serverTime={serverTimeStamp.current} />
                    <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={isMobile ? {} : { width: '1120px' }} />
                </div>
            </PageLayout>
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}
